import axios from "axios";
import config from "../config";
const { enquiryAPIUrl } = config;

/**
 * Sends enquiry email
 * 
 * @param {Object} values - The enquiry details to be sent.
 * @returns {Promise} - The axios promise for the HTTP request.
 */
export const enquiry = (values) => {
    return axios.post(`${enquiryAPIUrl}/enquiry?calculator=POSTCODE`, values);
};